import gql from 'graphql-tag';

export const ABOUT_US_PAGE_HEADER_FRAGMENT = gql`
  fragment aboutUsPageHeader on AboutUsPageHeaderType {
    headerImage
    headerTitle
    headerButtonText
    headerButtonUrl
    id
  }
`;
